import { ENDPOINT } from "constants/variables";
import { helpHttp } from "service/HelpHttp";

const blobToDataUrl = (blob) => new Promise((resolve, reject) => {
  const reader = new FileReader();
  reader.onload = () => resolve(reader.result);
  reader.onerror = reject;
  reader.readAsDataURL(blob);
});

/**
 * Adds the QR of the active DeCA document linked to a shipping document.
 * A missing DeCA is deliberately ignored so legacy shipping documents remain
 * printable while newly created/updated ones receive the verification QR.
 */
export const fetchShippingDecaQr = async (shippingId, token) => {
  if (!shippingId || !token) return '';
  try {
    const service = await helpHttp().get(
      ENDPOINT,
      `deca/transport-services/shipping/${shippingId}`,
      token
    );
    if (!service?.id) return '';

    const document = await helpHttp().get(
      ENDPOINT,
      `deca/documents/service/${service.id}/active`,
      token
    );
    if (!document?.publicToken) return '';

    const response = await fetch(
      `${ENDPOINT}/deca/documents/public/${document.publicToken}/qr`
    );
    if (!response.ok) return '';
    return blobToDataUrl(await response.blob());
  } catch (error) {
    return '';
  }
};

export const addDecaQrToShippingPdf = async (
  doc,
  shippingId,
  token,
  position = {}
) => {
  if (!doc || !shippingId || !token) return false;

  try {
    const qrDataUrl = await fetchShippingDecaQr(shippingId, token);
    if (!qrDataUrl) return false;
    const x = position.x ?? 167.5;
    const y = position.y ?? 150;
    const size = position.size ?? 20;
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(6);
    doc.text('DeCA verificable', x + (size / 2), y - 3, { align: 'center' });
    doc.addImage(qrDataUrl, 'PNG', x, y, size, size);
    return true;
  } catch (error) {
    return false;
  }
};
